export const stylesCP = {
  container: {
    minHeight: "100%",
    background: "#fff",
    padding: "24px 20px 32px 20px",
    overflowY: "scroll",
    scrollBehavior: "smooth",
  },
  title: {
    fontFamily: "AMX-Bold",
    fontSize: "16px",
    margin: "0px 0px 24px 0px",
    color: "#50626c",
    textAlign: "center",
  },
  formWrapper: {
    boxShadow: "0px 0px 30px 0px #26012024",
    padding: "24px 20px 32px 20px",
    borderRadius: "8px",
  },
  termsWrapper: {
    display: "inline-grid",
    columnGap: "14px",
    gridTemplateColumns: "auto auto",
    alignItems: "center",
    margin: "32px 0px 32px 0px",
  },
  termsTextWrapper: {
    textAlign: "justify",
    lineHeight: "20px",
  },
  termsText: {
    fontFamily: "AMX-Regular",
    fontSize: "12px",
    color: "#0f0f0f",
  },
  termsTextLink: {
    fontFamily: "AMX-Bold",
    fontSize: "12px",
    color: "#0f0f0f",
    textDecoration: "underline",
  },
  termsIframe: {
    border: "none",
    width: "100%",
    minHeight: "100%",
    overflowY: "scroll"
  },
  textSubtitle: {
    fontFamily: "AMX-Bold",
    fontSize: "12px",
    color: "#0f0f0f",
    display: "block",
  },
  textPhoneNumber: {
    fontFamily: "AMX-Regular",
    fontSize: "14px",
    color: "#848484",
  },
  phoneNumber: {
    fontFamily: "AMX-Regular",
    fontSize: "12px",
    color: "#474747",
  },
  imgBillTelcel: {
    width: "100%",
    verticalAlign: "bottom",
  },
  subtitleWrapper: {
    display: "inline-grid",
    columnGap: "14px",
    gridTemplateColumns: "20% 80%",
    alignItems: "center",
    margin: "0px 0px 24px 0px",
  },
  subtitle: {
    margin: "0px 0px",
  },
  buttonWrapper: {
    textAlign: "center",
  },
  inputDateWrapper: {
    margin: "24px 0px 0px 0px",
  },
};

export const stylesCT = {
  container: {
    minHeight: "100%",
    background: "#fff",
    padding: "24px 20px 32px 20px",
    overflowY: "scroll",
    scrollBehavior: "smooth",
  },
  title: {
    fontFamily: "AMX-Bold",
    fontSize: "16px",
    margin: "8px 0px 24px 0px",
    color: "#222222",
    textAlign: "center",
  },
  formWrapper: {
    boxShadow: "0px 0px 30px 0px #26012024",
    padding: "24px 20px 32px 20px",
    borderRadius: "16px",
  },
  termsWrapper: {
    display: "inline-grid",
    columnGap: "13px",
    gridTemplateColumns: "auto auto",
    alignItems: "center",
    margin: "32px 0px 32px 0px",
  },
  termsTextWrapper: {
    textAlign: "left",
    lineHeight: "100%",
  },
  termsText: {
    fontFamily: "AMX-Regular",
    fontSize: "14px",
    color: "#222222",
  },
  termsTextLink: {
    fontFamily: "AMX-Bold",
    fontSize: "14px",
    color: "#0071D1",
    textDecoration: "none",
  },
  termsIframe: {
    border: "none",
    width: "100%",
    minHeight: "100%",
    overflowY: "scroll"
  },
  textSubtitle: {
    fontFamily: "AMX-Bold",
    fontSize: "16px",
    color: "#222222",
    display: "block",
    lineHeight: "20px",
    fontWeight: "700"
  },
  textPhoneNumber: {
    fontFamily: "AMX-Regular",
    fontSize: "14px",
    color: "#222222",
  },
  phoneNumber: {
    fontFamily: "AMX-Regular",
    fontSize: "14px",
    color: "#222222",
  },
  imgBillTelcel: {
    width: "100%",
    verticalAlign: "bottom",
    maxWidth: "48px",
  },
  subtitleWrapper: {
    display: "inline-grid",
    columnGap: "14px",
    gridTemplateColumns: "max-content auto",
    alignItems: "center",
    margin: "0px 0px 24px 0px",
  },
  subtitle: {
    margin: "0px 0px",
  },
  buttonWrapper: {
    textAlign: "center",
  },
  inputDateWrapper: {
    margin: "24px 0px 0px 0px",
    position: "relative",
  },
  inputContent:{
    position: "relative",
  }
};